// `lang` and `dir` mark text in another language or script, for screen readers
// and for translation tools. Show notes keep them on every element, but only
// with a value of the shape of a BCP 47 language tag or a text direction.
//
// Keep these rules the same as `sanitize` in the Django app
// (`pinecast/helpers.py`), which cleans the show notes that are served.

const LANGUAGE_TAG = /^[A-Za-z]{1,8}(-[A-Za-z0-9]{1,8})*$/;
const TEXT_DIRECTIONS = ['ltr', 'rtl', 'auto'];

export const LANGUAGE_MARK_ATTRIBUTES: ReadonlyArray<string> = ['lang', 'dir'];

/**
 * Whether `value` is safe to keep in a `lang` or `dir` attribute. Nothing that
 * passes can break out of the attribute, but callers still escape it.
 */
export function isSafeLanguageMark(name: string, value: string): boolean {
  switch (name) {
    case 'lang':
      return LANGUAGE_TAG.test(value);
    case 'dir':
      // HTML reads `dir` without regard to case.
      return TEXT_DIRECTIONS.includes(value.toLowerCase());
    default:
      return false;
  }
}
